__turbopack_context__.v({
  "eventDashboardSurface": "eventDashboardGlobal-module-scss-module__MKaGvW__eventDashboardSurface",
});
